/* src/app/features/assets/components/asset-card/asset-card.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
:host {
  display: block;
  margin-right: 20px;
  flex-shrink: 0;
  color: var(--text_primary);
  position: relative;
}
:host.selected .item::after,
:host.selected .poster-circle::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 3px solid var(--highlight_primary);
  border-radius: inherit;
  pointer-events: none;
}
:host:not(.fluid).size-small.landscape {
  width: 293px;
  height: 165px;
}
:host:not(.fluid).size-small.portrait {
  width: 293px;
  height: 521px;
}
:host:not(.fluid).size-xsmall.portrait {
  width: 220px;
  height: 390px;
}
:host:not(.fluid).size-small.square {
  width: 293px;
  height: 293px;
}
:host:not(.fluid).size-medium.landscape {
  width: 360px;
  height: 203px;
}
:host:not(.fluid).size-medium.portrait {
  width: 360px;
  height: 640px;
}
:host:not(.fluid).size-medium.square {
  width: 360px;
  height: 360px;
}
:host:not(.fluid).size-large.landscape {
  width: 580px;
  height: 325px;
}
:host:not(.fluid).size-large.portrait {
  width: 450px;
  height: 800px;
}
:host:not(.fluid).size-large.square {
  width: 450px;
  height: 450px;
}
:host:not(.fluid).size-small.circle {
  width: 293px;
}
:host:not(.fluid).size-medium.circle {
  width: 360px;
}
:host:not(.fluid).size-large.circle {
  width: 450px;
}
:host.fluid {
  width: 100%;
  height: auto;
  margin-right: 0;
  flex-shrink: 1;
}
:host.fluid.landscape {
  aspect-ratio: 16/9;
}
:host.fluid.portrait {
  aspect-ratio: 9/16;
}
:host.fluid.square {
  aspect-ratio: 1/1;
}
:host.fluid.circle .poster-circle {
  width: 100%;
  height: auto;
  aspect-ratio: 1/1;
}
.br-tile {
  border-radius: calc(var(--tile_border_radius) / 10 * 20px);
}
.poster-placeholder {
  background-color: var(--background_primary_7, #222);
}
.shadow.bottom-shadow {
  background:
    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.85) 0%,
      rgba(0, 0, 0, 0) 60%);
  opacity: 0.75;
}
.text-shadow {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}
.timeline {
  background-color: var(--player_progress_bar);
  transition: width 0.25s ease-out;
}
.top-chart {
  position: absolute;
  left: 5px;
  top: 1px;
  text-shadow: 0 0 5px var(--background_primary_6);
  font-size: 80px;
  line-height: 64px;
  opacity: 0.45;
}
:host.radio {
  width: 200px;
  height: 200px;
}
:host.radio .radio-channel {
  width: 100%;
  height: 100%;
}
:host.radio .radio-channel:hover .radio-channel-container .buttons,
:host.radio .radio-channel.active .radio-channel-container .buttons {
  opacity: 1;
  transition: opacity 0.5s cubic-bezier(0.02, 0.01, 0.47, 1);
}
:host.radio .radio-channel:hover .radio-channel-circle {
  transform: scale(1.05);
  border-color: var(--highlight_primary);
}
:host.radio .radio-channel.active .radio-channel-circle {
  transform: scale(1.1);
  border: 4px solid var(--highlight_primary);
}
:host.radio .radio-channel.active .radio-channel-container {
  gap: 16px;
}
:host.radio .radio-channel.active .radio-channel-container .icon-container {
  width: 100px;
  height: 48px;
}
:host.radio .radio-channel.active .radio-channel-container .title-container {
  width: 150px;
}
:host.radio .radio-channel.active .radio-channel-container .title-container .title {
  color: var(--text_primary);
  font-weight: bold;
}
:host.radio .radio-channel-circle {
  width: 200px;
  height: 200px;
  border: 2px solid var(--text_secondary);
  border-radius: 50%;
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
}
:host.radio .radio-channel-container {
  gap: 14px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:host.radio .radio-channel-container .active-icon-container {
  width: 24px;
  height: 24px;
}
:host.radio .radio-channel-container .active-icon-container .icon {
  max-width: 100%;
  max-height: 100%;
}
:host.radio .radio-channel-container .icon-container {
  width: 85px;
  height: 40px;
}
:host.radio .radio-channel-container .icon-container .icon {
  max-width: 100%;
  max-height: 100%;
}
:host.radio .radio-channel-container .timeline {
  height: 6px;
  width: 104px;
  background-color: var(--text_tertiary);
  border-radius: 60px;
}
:host.radio .radio-channel-container .timeline .elapsed {
  height: 6px;
  background-color: var(--highlight_primary);
  border-radius: 60px;
}
:host.radio .radio-channel-container .title-container {
  width: 140px;
}
:host.radio .radio-channel-container .title-container .title {
  font-size: 14px;
  color: var(--text_secondary);
  height: 36px;
  width: 138px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}
:host.radio .radio-channel-container .buttons {
  gap: 24px;
  opacity: 0;
  transition: opacity 0.5s cubic-bezier(0.02, 0.01, 0.47, 1);
}
:host.radio .radio-channel-container .buttons img {
  width: 25px;
}
.poster-circle {
  position: relative;
  overflow: visible;
}
.poster-circle .poster-clip {
  border-radius: 50%;
}
:host:not(.fluid).size-small.circle .poster-circle {
  width: 293px;
  height: 293px;
}
:host:not(.fluid).size-medium.circle .poster-circle {
  width: 360px;
  height: 360px;
}
:host:not(.fluid).size-large.circle .poster-circle {
  width: 450px;
  height: 450px;
}
/*# sourceMappingURL=asset-card.css.map */
